import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InsureFundDetails } from '../../Models/Models/Instruments/InsureFundDetails';

declare var IS_RUNNING_IN_APP_POOL;

export class InsureFundClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instrumentCode: string, enableNpr: boolean): Promise<InsureFundDetails, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/InsureFund/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instrumentCode: instrumentCode, enableNpr: enableNpr }

    return AjaxWrapper.get<InsureFundDetails, any>(url, data);
  }
}

